<div class="row" style="max-width: 80%;margin-left: auto; margin-right: auto;">
    <div class="col-sm-3" style="display:flex;">
        <h4 class="page-label" style="text-align: left; align-self: end;">
            Portal: {{ portal?.name  || 'N/A' }}
        </h4>
    </div>
    <div class="col-sm-6">
        <h1 class="page-label">Outbound Validation - Dashboard</h1>
    </div>
    <div class="col-sm-3" style="display:flex;">
        <h4 class="page-label" style="text-align: right; align-self: end;">
            Container ID: {{ currentState?.current_attempt?.container_id || 'N/A' }}
        </h4>
    </div>
</div>

<table class="table tablesorter tablesorter-default table-bordered table-hover" data-toggle="table" role="grid" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <thead>
        <tr role="row" class="tablesorter-headerRow">
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">Item</th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">UPC(s)</th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">Batch</th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">Expected Quantity</th>
            <th class="header tablesorter-header tablesorter-headerUnSorted" scope="col" role="columnheader">Counted Quantity</th>
        </tr>
    </thead>
    <tbody>
        <tr role="row" *ngFor="let lineItem of currentState?.current_attempt?.line_items; index as i; trackBy: trackByFunction"
            [class.green-highlight]="isSuccessRow(lineItem)"
            [class.red-highlight]="isErrorRow(lineItem)"
            [class.yellow-highlight]="isPartialRow(lineItem)"
            [class.gray-highlight]="isUnknownRow(lineItem)">
            <td>{{ lineItem?.item }}</td>
            <td>{{ lineItem?.upcs }}</td>
            <td>{{ lineItem?.batch }}</td>
            <td>{{ lineItem?.expected_quantity }}</td>
            <td>{{ lineItem?.counted_quantity }}</td>
        </tr>
    </tbody>
</table>

<div class="row" style="max-width: 80%; margin-left: auto; margin-right: auto;">
    <div class="col-sm-6">
        <button class="btn btn-primary" (click)="onStartReaderClicked()"
            [disabled]="currentState?.reader_state === 'Started' || isActionBeingPerformed">
            Start Reader
        </button>
        &nbsp;
        <button class="btn btn-primary" (click)="onStopReaderClicked()"
            [disabled]="currentState?.reader_state !== 'Started' || isActionBeingPerformed">
            Stop Reader
        </button>
    </div>
    <div class="col-sm-6 text-right">
        <button class="btn btn-primary" (click)="onClearReadsClicked()" [disabled]="isActionBeingPerformed">
            Clear Read(s)
        </button>
        &nbsp;
        <button class="btn btn-primary" (click)="onClearAttemptClicked()" [disabled]="isActionBeingPerformed">
            Clear Attempt
        </button>
        &nbsp;
        <button class="btn btn-primary" (click)="onProcessAttemptClicked()" [disabled]="isActionBeingPerformed">
            Process Attempt
        </button>
    </div>
</div>
<div class="print-container">
    <h1 class="page-label">&nbsp;</h1>
</div>

<ef-simple-success-error-dialog-box #successErrorDialog></ef-simple-success-error-dialog-box>

<!-- Simple Indefinite Dialog - Used to display a progress indicator when performing actions. -->
<ef-simple-indefinite-progress-dialog></ef-simple-indefinite-progress-dialog>